import styled from 'styled-components';

import colors from 'pubweb-react-components/dist/styles/colors';

import LandingPageStyles from '../../styles/LandingPageStyles';

const LandingCardContainer = styled.div`

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: ${colors.wsWhite};
    cursor: pointer;
    position: relative;

    a, a:hover, a:visited {
       color:  ${colors.wsWhite};
       text-decoration: none;
    }
    h1 { 
        display: inline-block;
    }

    .body-copy-component {
        display: block;
        margin: 0 auto;
    }

    .card-line {
        display: block;
    }
    
    .card-filter {
        background-color: rgba(70, 70, 80, .21);
        height: 100%;
    }

    .inner-card-container {
        display: block;
        margin: auto;
        position: absolute;
        text-align: center;
        width: 100%;
    }

    /* - DESKTOP VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}) {
        background-image: url('${(props) => props.styleProps.desktopView.backgroundImage}');
        display: inline-block;
        float: left;
        height: 100%;
        width: 33.3%;

        &:nth-child(2) {
            width: 33.4%
        }

        .body-copy-component {
            display: block;
            font-size: 23px;
            letter-spacing: .55px;
            text-shadow: 0 0 1px ${colors.wsWhite};
            width: 350px;
        }

        .heading-component {
            display: inline-block;
            height: 68px;
            margin-bottom: -4px;

            h1 {
                
                font-size: 48px;
                font-weight: 900;
                letter-spacing: -1px;
                position: relative;
                z-index: ${LandingPageStyles.zIndices.headerText};
            }

            &:after {
                background-color: ${(props) => props.styleProps.animationColor};
                content: "none";
                display: block;
                font-size: 0;
                height: 31px;
                margin-bottom: -31px;
                margin-left: -20px;
                margin-right: -20px;
                top: -30px;
                -webkit-transition: width .5s;
                transition: width .5s;
                -webkit-transition-timing-function: cubic-brezier(.2, 1, 0.3, 1);
                transition-timing-function: cubic-brezier(.2, 1, 0.3, 1);
                position: relative;
                width: 0;
                z-index: ${LandingPageStyles.zIndices.headerBackground};
            }
        }
        
        .inner-card-container {
            top: 40.1%;

            @media screen and (max-height: 768px) {
                bottom: 30%;
                top: auto;
            }

            @media screen and (max-height: 600px) {
                bottom: auto;
                top: 30%;
            }
        }

        &:nth-child(1){ 
            &:hover {
                .heading-component:after {
                    width: 204px;
                }
            }
        }

        &:nth-child(1) .inner-card-container {
            .body-copy-component {
                line-height: 29px;
                margin-top: -5px;
                padding-left: 4px;
            }

            .circle-arrow {
                margin-top: 37px;
                padding-left: 3px;
            }
        }

        &:nth-child(2){ 
            &:hover {
                .heading-component:after {
                    width: 325px;
                }
            }
        }
    
        &:nth-child(2) .inner-card-container {
            margin-bottom: 5px;

            .body-copy-component {
                line-height: 29px;
                margin-top: -2px;
                padding-left: 12px;
            }

            .circle-arrow {
                margin-top: 36px;
                padding-left: 2px;
            }
        }

        &:nth-child(3){ 
            &:hover {
                .heading-component:after {
                    width: 157px;
                }
            }
        }
    
        &:nth-child(3) .inner-card-container {

            .body-copy-component {
                line-height: 29px;
                margin-top: -2px;
            }

            .circle-arrow {
                margin-top: 36px;
                padding-left: 0px;
            }
        }
    }
    
    /* - TABLET VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}) {
        background-image: url('${(props) => props.styleProps.tabletView.backgroundImage}');
        height: 33.3%;
        width: 100%;

        &:first-child {
            height: 33.4%;
        }
        
        .body-copy-component {
            font-size: 21px;
            letter-spacing: .85px;
            line-height: 1.24;
            text-shadow: 0 0 1px ${colors.wsWhite};
            width: 305px;
        }

        .heading-component {
            h1 {
                font-size: 32px;
                font-weight: 900;
                letter-spacing: -.7px;
            }

        }

        &:nth-child(1) .inner-card-container {
            top: 28.5%;
            
            @media screen and (max-height: 800px) {
                top: auto;
                bottom: 10%;
            }

            .heading-component {
                margin-bottom: 7px;
            }

            .body-copy-component {
                line-height: 26px;
            }

            .circle-arrow {
                margin-top: 12px;
            }
        }
    
        &:nth-child(2) .inner-card-container {
            top: 32.5%;

            @media screen and (max-height: 800px) {
                top: auto;
                bottom: 10%;
            }

            .heading-component {
                margin-bottom: 3px;
            }

            .body-copy-component {
                line-height: 26px;
            }

            .circle-arrow {
                margin-top: 14px;
            }
        }
    
        &:nth-child(3) .inner-card-container {
            top: 26.6%;

            @media screen and (max-height: 800px) {
                top: auto;
                bottom: 12%;
            }

            .heading-component {
                margin-bottom: 4px;
            }

            .body-copy-component {
                letter-spacing: 1.25px
                line-height: 28px;
            }

            .circle-arrow {
                margin-top: 9px;
            }
        }

         /* - MOBILE VIEW - */
        @media screen and (${LandingPageStyles.viewBreakpoints.mobile}) {
            background-image: url('${(props) => props.styleProps.mobileView.backgroundImage}');
            height: 33.3%;
            width: 100%;

            &:nth-child(1n) {
                &:hover {
                    height: 33.3%;
                    width: auto;
                }
            }
            &:first-child {
                height: 33.4%;

                &:hover {
                    height: 33.4%;
                    width: auto;
                }
            }
            .body-copy-component {
                font-size: 18px;
                letter-spacing: .7px;
                line-height: 1.28;
                width: 285px;
            }

            .heading-component {
                h1 {
                    font-size: 32px;
                    font-weight: 900;
                    letter-spacing: -.7px;
                }
            }

            &:nth-child(1) .inner-card-container {
                top: 18.5%;

                .body-copy-component {
                    line-height: 23px;
                }

                 .heading-component {
                    margin-bottom: 1px;
                }

                .circle-arrow {
                    margin-top: 6px;
                    padding-left: 1px;
                }
            }
            

            &:nth-child(2) .inner-card-container {
                top: 25%;

                .body-copy-component {
                    line-height: 22px;
                }

                 .heading-component {
                    margin-bottom: -2px;
                }

                .circle-arrow {
                    margin-top: 8px;
                }
            }

            &:nth-child(3) .inner-card-container {
                top: 11.5%;

                .body-copy-component {
                    letter-spacing: .7px;
                    line-height: 23px;
                }

                 .heading-component {
                    margin-bottom: 2px;
                }

                .circle-arrow {
                    margin-top: 5px;
                }
            }
        }
   `;

export default LandingCardContainer;



// WEBPACK FOOTER //
// ./src/components/LandingCard/LandingCardStyles.js